<template>
    <div id="services">
        <el-main class="services-section">
            <el-row align="middle" justify="center">
                <el-col :span="24">
                    <h2>我们的服务</h2>
                    <el-divider>我们服务于船舶、电力、化工、环保、矿山、市政、隧道等行业</el-divider>
                    <el-carousel height="650px" type="card">
                        <el-carousel-item v-for="item in images" :key="item">
                            <div class="carousel-content">
                                <el-image :src="item" style="width: 99%; height: 99%;"/>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                    <p></p>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-card>
                                <h3>创新应用</h3>
                                <p>提供基于工业物联网的创新应用解决方案。</p>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card>
                                <h3>市场节能</h3>
                                <p>
                                    &emsp;&emsp;致力于市场节能，推动可持续发展。实行马达新能效等级，引导企业实施电机等重点用能设备更新升级，优先选用高效节能电机，加快淘汰不符合现行国家能效标准要求的落后低效电机。
                                </p>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card>
                                <h3>定制方案</h3>
                                <p>根据客户需求提供定制化的动力传输系统解决方案。</p>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-main>
    </div>
</template>

<script setup>
import {ref} from "vue";
import ship from '@/assets/servicesImg/ship.jpg'
import power from '@/assets/servicesImg/power.jpg'
import chemistry from '@/assets/servicesImg/chemistry.jpg'
import environment from '@/assets/servicesImg/environment.jpg'
import mine from '@/assets/servicesImg/mine.jpg'
import city from '@/assets/servicesImg/city.jpg'
import tunnel from '@/assets/servicesImg/tunnel.jpg'

const images = ref([ship, power, chemistry, environment, mine, city, tunnel])
</script>

<style scoped>
.services-section {
    width: 70%;
    margin: auto;
}

.services-section h2 {
    font-size: 30px;
    margin-bottom: 30px;
    text-align: center;
}

.el-card {
    text-align: left;
}

.el-card h3 {
    font-size: 24px;
    margin-bottom: 10px;
}

.el-card p {
    font-size: 16px;
    color: #666;
}

.el-carousel__item h3 {
    color: #475669;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
    text-align: center;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
}

.carousel-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}
</style>